export default {
    id: 'pink-gray-green',
    colors: ['#D0A3FF', '#D8D8D8', '#8EEDCB'],
};
